import { IQueryTypeFragments } from '~api/QueryFragments';
import { QueryType } from './Default';

const loyaltyLevelCurrentFragment = `
    on ${QueryType.loyaltyLevelCurrent} {
        daysToAnniversary
        level
        pointsMultiplier
        qualifying
        rbTierName
        points{
            currentPending
            currentAvailable
            qualifying
            available
        }
        spend{
            currentPending
            currentAvailable
            qualifying
        }
    }
`;

export const loyaltyLevelCurrentFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.loyaltyLevelCurrent]: loyaltyLevelCurrentFragment
    };
};
